import type { ReactNode } from 'react';

export interface ChartEmptyProps {
  /** Message shown to the user. Default `"No data available"`. */
  message?: ReactNode;
  className?: string;
}

/**
 * Centered muted text in a div that fills its parent — used as the
 * empty-state inside a `<ChartCard>` when a series returns no points.
 */
export function ChartEmpty({
  message = 'No data available',
  className,
}: ChartEmptyProps): JSX.Element {
  const classes = [
    'flex h-full w-full items-center justify-center text-sm text-[color:var(--text-dark)] opacity-60',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <div className={classes}>{message}</div>;
}

export default ChartEmpty;
